<template>
        <div class="user_bottom">
      <div class="copyright">
        <div>版权所有@地球大数据科学工程专项/数字一带一路(DBAR)专项</div>
        <div>
          <img src="../../assets/image/User/copyright.png" />京ICP备17072443号
        </div>
      </div>
      <div class="statement">
        <ul>
          <li>法律声明</li>
          <li>|</li>
          <li>隐私政策声明</li>
          <li>|</li>
          <li>Cookies</li>
        </ul>
      </div>
    </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped >
 .user_bottom {
    height: 70px;
    //   width: 100%;
    padding: 0 20px;
    background: #fff;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    .copyright {
      font-size: 14px;
      color: #333;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      div {
        display: flex;
        flex-direction: row;
        align-items: center;
        img {
          margin-right: 10px;
        }
      }
    }
    .statement {
      ul {
        display: flex;
        flex-direction: row;
        li {
          font-size: 14px;
          margin-right: 20px;
          color: #333;
        }
      }
    }
  }
</style>